<template>
  <div class="text-sm md:text-md">
    <label v-if="label" class="form-label text-sm text-gray-600">{{ label }}</label>
    <div class="mt-2" :class="{ 'error': errors.length }">
      <input ref="file" type="file" :accept="accept" class="hidden" @change="change">
      <div v-if="!modelValue">
        <action-button @click="browse" class="w-full md:w-auto" secondary>
          <slot>Choose File</slot>
        </action-button>
      </div>

      <div v-else class="flex items-center justify-between">
        <div class="flex-1 pr-1">
          {{ modelValue.name }}
          <span class="text-gray-500 text-xs">({{ filesize(modelValue.size) }})</span>
        </div>

        <action-button icon class="ml-2" danger @click="remove">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </action-button>
      </div>
    </div>

    <div v-if="errors.length" class="text-red-500">{{ errors[0] }}</div>
  </div>
</template>

<script>
import { ActionButton } from '@/Components'

export default {
  components: {
    ActionButton,
  },

  props: {
    modelValue: File,
    label: String,
    accept: String,
    errors: {
      type: Array,
      default: () => []
    },
  },

  watch: {
    modelValue(modelValue) {
      if (!modelValue) {
        this.$refs.file.modelValue = ''
      }
    }
  },

  methods: {
    filesize(size) {
      let i = Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },

    browse() {
      this.$refs.file.click()
    },

    change(e) {
      this.$emit('update:modelValue', e.target.files[0])
    },

    remove() {
      this.$emit('update:modelValue', null)
    }
  }
}
</script>
